/* eslint-disable no-undef */
import './App.css';
import { createBrowserRouter, RouterProvider, useLocation, Outlet } from 'react-router-dom';
import HeroPage from './Components/HomePage';
import LegalLandingPage from './Components/LandingPage';
import "leaflet/dist/leaflet.css";
import React, { useEffect } from "react";
import Component2 from "./Components/Component2";
import LocationCard from "./Components/LocationCard";
// import LegalLandingPage from './Components/LandingPage';
import LegalLandingPage2 from './Components/LandingPage2';
import LegalLandingPage3 from './Components/LandingPage3';
import LegalLandingPage4 from './Components/LandingPage4';
import ContactUs from './Components/ContactUs';
import Disclaimer from './Components/Disclaimer';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ContactMain from './Components/ContactUsMain';
import AboutUsMain from './Components/AboutUsMain';
import PdfPage from './Components/PdfPage';
import InjuryCompensationMain from './Components/InjuryCompensation/InjuryCompensationMain.jsx'
import LegalLandingPage5 from './Components/LandingPage5';
import LegalLandingPage6 from './Components/LandingPage6';
import ClaimReview from './Components/ClaimReview';
import ClaimReview2 from './Components/ClaimReview2.jsx';
import ClaimReview3 from './Components/ClaimReview3.jsx';
import ClaimReview4 from './Components/ClaimReview4.jsx';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-9GXXHBHPBV')

// Layout component (can be used for route-level logic if needed)
function Layout() {
  const location = useLocation();

  useEffect(() => {
    // Reserved for generic page view tracking if needed.
    // Google Ads "Page view" conversion is now handled ONLY in ClaimReview3.
  }, [location.pathname]);

  return <Outlet />;
}

function App() {
  

  const router = createBrowserRouter([
    {
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <HeroPage />, 
        },
        {
          path: '/legal',
          element: <LegalLandingPage />,
        },
        {
          path: '/Component2',
          element: <Component2 />,
        },
        {
          path: '/Disclaimer',
          element: <Disclaimer />,
        },
        {
          path: '/PrivacyPolicy',
          element: <PrivacyPolicy />,
        },
        {
          path: '/accident-1/Nevada',
          element: <LegalLandingPage />,
        },
        {
          path: '/accident-1/California',
          element: <LegalLandingPage2 />,
        },
        {
          path: '/accident-1/Colorado',
          element: <LegalLandingPage3 />,
        },
        {
          path: '/accident-1/Washington',
          element: <LegalLandingPage4 />,
        },
        {
          path: '/accident-1/Texas',
          element: <LegalLandingPage5 />,
        },
        {
          path: '/accident-1/Georgia',
          element: <LegalLandingPage6 />,
        },
        {
          path: '/free-labor-day-guide',
          element: <PdfPage />,
        },
        {
          path: '/contactus',
          element: <ContactMain />,
        },
        {
          path: '/aboutus',
          element: <AboutUsMain />,
        },
        {
          path: '/LeadForm-MVA1',
          element: <InjuryCompensationMain />, 
        },
        {
          path: '/lander',
          element: <ClaimReview />,
        },
        {
          path: '/lander2',
          element: <ClaimReview2 />,
        },
        {
          path: '/lander3',
          element: <ClaimReview3 />,
        },
        {
          path: '/lander4',
          element: <ClaimReview4 />,
        },
        {
          path: '*',
          element: <h1>404 - Page Not Found</h1>,
        },
      ],
    },
  ]);

  return (
     <RouterProvider router={router} />
  );
}

export default App;
